import {
  RECEIVE_CLAIMS_ENABLED,
  RECEIVE_CLAIMS_SIDEBAR_INIT,
  RECEIVE_CLAIMS_SIDEBAR_TOGGLE,
  RESET_CLAIMS_SIDEBAR,
  RECEIVE_SIDEBAR_CLAIM_ITEM,
} from '../../actions/claims';

export const initialState = {
  enabled: false,
  sidebarOpen: false,
  sidebarItem: undefined,
};

export default (
  state = initialState,
  { type, data: { enabled, sidebarOpen, sidebarItem } = {} } = {},
) => {
  switch (type) {
    case RECEIVE_CLAIMS_ENABLED:
      return {
        ...state,
        enabled,
      };

    case RECEIVE_CLAIMS_SIDEBAR_INIT:
      return {
        ...state,
        sidebarOpen: true,
        sidebarItem,
      };

    case RECEIVE_CLAIMS_SIDEBAR_TOGGLE:
      return {
        ...state,
        sidebarOpen,
      };

    case RESET_CLAIMS_SIDEBAR:
      return {
        ...state,
        sidebarOpen: initialState.sidebarOpen,
        sidebarItem: initialState.sidebarItem,
      };

    case RECEIVE_SIDEBAR_CLAIM_ITEM:
      return {
        ...state,
        sidebarItem,
      };

    default:
      return state;
  }
};
